import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { ShippingConfigFormContext } from 'context';
import type {
  ComponentMode,
  ShippingConfig as ShippingConfigConfig,
} from 'types';

import { ShippingConfigForm, ShippingConfigHeader } from './components';

type ShippingConfigProps = {
  mode: ComponentMode;
};

export default function ShippingConfig({ mode }: ShippingConfigProps) {
  const data = useLoaderData() as ShippingConfigConfig | undefined;

  const { title: shippingConfigTitle } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode
    ? shippingConfigTitle
    : 'افزودن تنظیمات ارسال جدید';
  const defaultTitle = isUpdatedMode ? shippingConfigTitle : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <ShippingConfigHeader>{title}</ShippingConfigHeader>
      <ShippingConfigFormContext
        mode={mode}
        defaultTitle={defaultTitle}
        {...(isUpdatedMode ? data : {})}
      >
        <ShippingConfigForm />
      </ShippingConfigFormContext>
    </React.Fragment>
  );
}
